import { get } from '@/services/api/axiosClient'
import { BusinessChainDTOListApiResponse } from '@/types/__generated__/companies'

import { CommerceDetailDTO, ReadCompanySearchResultApiResponse } from '@/types/__domain__/companies'

export const fetchBusinessChains = async (): Promise<BusinessChainDTOListApiResponse> => {
    const url = '/api/companies/availablechains'

    const response = await get(url)
    return response.data
}

export const fetchChamberOfCommerceQuery = async (
    searchTerm: string
): Promise<ReadCompanySearchResultApiResponse> => {
    const url = `/api/companies/commerce-number/search?searchTerm=${searchTerm}`

    const response = await get(url)
    return response.data
}

export const fetchChamberOfCommerceDetails = async (id: string): Promise<CommerceDetailDTO> => {
    const url = `/api/companies/commerce-number/details?id=${id}`

    const response = await get(url)
    return response.data?.data
}
